// Centralised brand asset URLs (customer CDN). Media Manager (Batch E) will
// override these per-slot from the backend; until then UI falls back to these
// originals. Keep this file authoritative — never hard-code asset URLs elsewhere.
const ROOT = "https://customer-assets.emergentagent.com/job_research-nexus-55/artifacts";

export const BRAND_ASSETS = {
  // Logos
  logoHorizontalDark: `${ROOT}/gxzlijjz_Horizental_logo__dark_and_purple.png`,
  logoHorizontalWhite: `${ROOT}/z6lnw076_Horizental_logo__white_and_purple.png`,
  logoMainDark: `${ROOT}/6cq4yzw6_Main_logo_dark_purple.png`,
  logoMainWhite: `${ROOT}/8ggwy6qc_Main_logo_white_purple.png`,
  logoShapePurple: `${ROOT}/432i3x7z_Logo_shape_only_white_and_purple.png`,
  logoMono: `${ROOT}/r9475s0y_KhojByte%20Research%20Lab%20Mono%20logo.png`,

  // Symbols / decor
  kShapePurple: `${ROOT}/4t1strx2_K_shape_purple_only.png`,
  kShapeWhite: `${ROOT}/8p0bwt93_K_shape_white_only.png`,
  kShapeDark: `${ROOT}/czg02lkw_K_shape_dark_only.png`,
  oGlassPurple: `${ROOT}/gpdyxcis_O_magnifying_glass_purple.png`,
  oGlassWhite: `${ROOT}/8r55paoj_O_magnifying_glass_white.png`,
  hexagonWhite: `${ROOT}/9gwcrvwu_Hexagon_white.png`,
  hexGroup: `${ROOT}/cdupbk6k_Hex_group.png`,
  hexGroupGrey: `${ROOT}/fsp71h5m_Hex_group_grey.png`,

  // People / photography
  teamLookingLaptop: `${ROOT}/a871iejr_team_looking_laptop.jpeg`,
  teamHandshake: `${ROOT}/0k1p3964_team_handshake.jpeg`,
  girlPointRight: `${ROOT}/o2cyt4dn_girl_pointing_right.png`,
  girlSurprisedLeft: `${ROOT}/fqx4wdnx_surprised_girl_pointing_left.png`,
  girlThumbsUp: `${ROOT}/9ft5g12a_formal_girl_both_thumbs_up.png`,
  girlCrossHand: `${ROOT}/mwtb0j35_girl_cross_hand.png`,
  girlProfessional: `${ROOT}/7a6i4lpg_professional_girl.png`,
  girlCoffeeLaptop: `${ROOT}/y1mysrag_professional_girl_with_coffee_and_laptop.png`,
  companyBoard: `${ROOT}/li9a6fhw_company_holding_board.png`,
  testimonials: `${ROOT}/j26s2c0i_client_testimonials.png`,
};

// Slot → default asset URL. Media Manager will look up these slot keys.
export const BRAND_SLOTS = {
  "logo.horizontal.dark": BRAND_ASSETS.logoHorizontalDark,
  "logo.horizontal.white": BRAND_ASSETS.logoHorizontalWhite,
  "logo.shape.purple": BRAND_ASSETS.logoShapePurple,
  "hero.primary": BRAND_ASSETS.teamLookingLaptop,
  "section.team.handshake": BRAND_ASSETS.teamHandshake,
  "section.team.board": BRAND_ASSETS.companyBoard,
  "section.testimonials": BRAND_ASSETS.testimonials,
  "decor.hex.group": BRAND_ASSETS.hexGroup,
  "decor.k.purple": BRAND_ASSETS.kShapePurple,
  "decor.o.glass": BRAND_ASSETS.oGlassPurple,
  "persona.point-right": BRAND_ASSETS.girlPointRight,
  "persona.surprised-left": BRAND_ASSETS.girlSurprisedLeft,
  "persona.thumbs-up": BRAND_ASSETS.girlThumbsUp,
  "persona.cross-hand": BRAND_ASSETS.girlCrossHand,
  "persona.coffee-laptop": BRAND_ASSETS.girlCoffeeLaptop,
  "persona.professional": BRAND_ASSETS.girlProfessional,
};

// Lightweight in-memory cache for Media-Manager overrides; populated by
// `useMediaSlots()` on app mount (Batch E). Until backend endpoint lands the
// map is empty and BRAND_SLOTS defaults are returned.
let _overrides = {};
export function setMediaOverrides(map) { _overrides = map || {}; }
export function getSlot(slotKey, fallback) {
  return _overrides[slotKey] || BRAND_SLOTS[slotKey] || fallback || "";
}
